import React, {Fragment} from "react";
import {Field, useFormState} from "react-final-form";
import Error from "./Error";
import InputField from "./InputField";
import PropTypes from "prop-types";

function OtherField({name, watch, validate}) {
    const {values} = useFormState();
    const parentValue = values[watch] ? values[watch].toString().toLowerCase() : undefined;

    if (parentValue !== 'other') {
        return null;
    }

    return <Fragment>
        <Field
            name={name}
            component={InputField}
            placeholder="Type here"
            validate={validate}
            className="control-input control-input--other"
            autoComplete="off"
        />
        <Error name={name} />
    </Fragment>
}

OtherField.propTypes = {
    name: PropTypes.string.isRequired,
    watch: PropTypes.string.isRequired,
    validate: PropTypes.func,
}

export default OtherField;